import React from "react";
import Profile from "./index";
function CompanyProfile() {
  return (
    <div className="p-4">
      <Profile />
    </div>
  );
}

export default CompanyProfile;
